<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" title="我的报告" />
    </van-sticky>
		<div class="search-list">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        finished-text="没有更多了"
        @load="onLoad">
        <div v-for="(item,index) in tabData" :key="index" :class="item.type.key">
          <!-- 信息 -->
          <div class="flex-row-between" style="padding-right: 16px">
            <!-- <div class="baseinfo flex-row-start">
              <div v-if="item.studentBasePO.name" class="font-intro">姓名：{{ item.studentBasePO.name }}</div>
              <div v-if="item.userAuthPO.name" class="font-intro">姓名：{{ item.userAuthPO.name }}</div>
            </div> -->
            <div class="baseinfo flex-row-start">
              <img v-if="item.type.key == 'User'" class="headimg" src="../../../assets/images/user-head.jpg" />
              <img v-if="item.type.key == 'Student'" class="headimg" src="../../../assets/images/headimg.jpg" />
              <div v-if="item.testingId != 7 && item.userAuthPO">
                <div class="flex-row-start">
                  <div v-if="item.userAuthPO" class="font-bigger name">{{ item.userAuthPO.name }}</div>
                  <div v-if="item.userAuthPO">
                    <img v-if="item.userAuthPO.sex.key == 'Female'" src="../../../assets/images/male.png" class="sex" />
                    <img v-if="item.userAuthPO.sex.key == 'Male'" src="../../../assets/images/female.png" class="sex" />
                  </div>
                </div>
                <div v-if="item.userAuthPO.height || item.userAuthPO.weight" class="detailinfo flex-row-start">
                  <div v-if="item.userAuthPO.height" class="font-intro">{{ item.userAuthPO.height }}cm</div>
                  <div v-if="item.userAuthPO.weight" class="font-intro">{{ item.userAuthPO.weight }}kg</div>
                </div>
              </div>
              <div v-if="item.testingId != 7 && item.studentBasePO">
                <div class="flex-row-start">
                  <div v-if="item.studentBasePO" class="font-bigger name">{{ item.studentBasePO.name }}</div>
                  <div v-if="item.studentBasePO">
                    <img v-if="item.studentBasePO.sex.key == 'Female'" src="../../../assets/images/male.png" class="sex" />
                    <img v-if="item.studentBasePO.sex.key == 'Male'" src="../../../assets/images/female.png" class="sex" />
                  </div>
                </div>
                <div v-if="item.studentBasePO.height || item.studentBasePO.weight" class="detailinfo flex-row-start">
                  <div v-if="item.studentBasePO.height" class="font-intro">{{ item.studentBasePO.height }}cm</div>
                  <div v-if="item.studentBasePO.weight" class="font-intro">{{ item.studentBasePO.weight }}kg</div>
                </div>
              </div>
            </div>
            <div class="font-bigger name">{{ item.testingName }}</div>
          </div>
          <!-- <van-cell title="名称" :value="item.testingName" :border="false" /> -->
          <!-- 档案 -->
          <div v-if="item.testingId != 7 && item.studentBasePO" class="content">
            <div v-if="item.studentBasePO.birth" class="font-intro">生日：{{ item.studentBasePO.birth | birthFilter }}</div>
          </div>
          <!-- 用户 -->
          <div v-if="item.testingId != 7 && item.userAuthPO" class="content">
            <div v-if="item.userAuthPO.birth" class="font-intro">生日：{{ item.userAuthPO.birth | birthFilter }}</div>
            <div v-if="item.userAuthPO.state" class="font-intro">状态：{{ item.userAuthPO.state.name }}</div>
          </div>
          <!-- 按钮 -->
          <div class="bottom flex-row-between">
            <div class="state">{{ item.state.name }}</div>
            <div class="flex-row-end">
              <div v-if="item.state.key == 'Ing'">
                <van-button v-if="item.testingId == 7" @click="toAccurateTesting(item)" round type="primary" size="small">填写问卷</van-button>
                <van-button v-if="item.testingId != 7" @click="toTesting(item)" round type="primary" size="small">填写问卷</van-button>
              </div>
              <div v-if="item.testingId != 7 && item.state.key == 'Finish'">
                <van-button @click="toTesting(item)" round type="primary" size="small">查看问卷</van-button>
              </div>
              <div v-if="item.state.key == 'Finish' && !item.experientialFlag" class="ml10">
                <van-button @click="showReport(item.resultUrlNew)" round type="default" size="small">查看报告</van-button>
              </div>
              <div v-if="item.state.key == 'Finish' && item.experientialFlag" class="ml10">
                <van-button @click="showFreeReport(item)" round type="default" size="small">简版报告</van-button>
              </div>
              <div v-if="item.testingId != 7 && (item.state.key == 'ToBePaid')">
                <van-button @click="payClick(item)" round type="primary" size="small">立即支付</van-button>
              </div>
              <div v-if="item.testingId != 7 && (item.state.key == 'Finish' && item.experientialFlag)" class="ml10">
                <van-button @click="buyClick(item)" round type="primary" size="small">解锁完整版</van-button>
              </div>
            </div>
          </div>
        </div>
      </van-list>
		</div>
  </div>
</template>
<script>
import { freeAuth, h5Free } from '@/api/testing-record'
import { isWeiXin } from '@/utils/tools'
import { fetchTestingRecord, continuePay } from "../../../api/testing-record"
export default {
  data() {
    return {
      typeBg: {
        'User': '../../../assets/images/user-bg.png',
        'Student': '../../../assets/images/student-bg.png'
      },
      searchValue: '',
      offset: 100,//滚动条与底部距离小于 offset 时触发load事件，默认300
      pageNum: -1, // 当前页码
      pageSize: 10, // 分页大小
      total: 0, // 查询总条数
      loading: false, // 滚动加载中
      finished: false, // 滚动加载完成
      tabData: []
    };
  },
  filters: {
    birthFilter(val) {
      if (val) {
        return val.split(' ')[0]
      }
      return val
    }
  },
  components: {
  },
  created() {
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    buyClick(item) {
      // 确认了，支付
      if (isWeiXin()) {
        // 公众号支付
        freeAuth({
          testingRecordId: item.id
        }).then(res => {
          window.location.href = res
        })
      } else {
        // h5支付
        h5Free({
          testingRecordId: item.id
        }).then(res => {
          this.payOrderId = res.id
          localStorage.setItem('payOrderId', res.id)
          localStorage.setItem('testingRecordId', item.id)
          // 保存
          if (res.state.key == 'Succeed') {
            window.href.reload()
          } else {
            // 跳转支付
            location.href = res.payJson + '&redirect_url=' + encodeURIComponent(location.href.replace('free-report', 'testing-record') + '&t=' + new Date().getMilliseconds())
          }
        })
      }
    },
    payClick(item) {
      // 支付
      continuePay({
        testingRecordId: item.id
      }).then(res => {
        this.onBridgeReady(JSON.parse(res.payJson), item)
      })
    },
    onBridgeReady(data, item) {
      console.info(data)
        WeixinJSBridge.invoke('getBrandWCPayRequest', {
            "appId": data.appId,     //公众号ID，由商户传入
            "timeStamp": data.timeStamp + "",     //时间戳，自1970年以来的秒数
            "nonceStr": data.nonceStr,      //随机串
            "package": data.package1,
            "signType": data.signType,     //微信签名方式：
            "paySign": data.sign //微信签名
        },
        (res) => {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              this.init()
              // 成功，跳转
              this.$router.push({
                path: '/testing-info',
                query: {
                  testingId: item.testingId,
                  testingRecordId: item.id
                }
              })
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            }
        })
    },
    toAccurateTesting(item) {
      // 去精准问卷
      window.location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId='+ localStorage.getItem('Tel') +'&inspectOrder='+ item.times +'&role=1&allow=true&companyId='+ item.companyId +'&isEdit=1'
    },
    toTesting(item) {
      localStorage.setItem('TestingRecordId', item.id)
      this.$router.push({
        path: '/testing-info',
        query: {
          testingId: item.testingId,
          testingRecordId: item.id
        }
      })
    },
    showFreeReport(item) {
      this.$router.push({
        path: "/free-report",
        query: {
          testingRecordId: item.id
        },
      })
    },
    showReport(url) {
      this.$router.push({
        path: "/show-report",
        query: {
          url: url
        },
      })
    },
    onClickLeft() {
      // history.back()
      this.$router.push({
        path: '/mine',
        query: {}
      })
    },
    init() {
      this.$nextTick(() => {
        this.handleButtonSearchInfors()
      })
    },
    //点击键盘上的搜索/回车按钮后触发
    handleEnterSearchInfors(val) {
      console.log(val);
    },
    handleButtonSearchInfors() {
      this.pageNum = 0
      this.tabData = []
      this.loadData()
    },
    // 滚动加载更多
    onLoad() {
      this.pageNum++
      this.loadData()
    },
    loadData() {
      fetchTestingRecord({
        keyWord: this.searchValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }, {}).then(res => {
        var data = res.content
        this.loading = false
        this.tabData = this.tabData.concat(data)
        if (data.length < this.pageSize) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../assets/css/style.css');
.search-container {
  padding: 0.66667rem;
  background-repeat: no-repeat;
  background-size: 100%;
}
.van-search {
  border-radius: 20px;
  /deep/ .van-search__content {
    background-color: #31607b;
  }
  /deep/ input::-webkit-input-placeholder {
    color: #999;
  }
  /deep/ input::-moz-input-placeholder {
    color: #999;
  }
  /deep/ input::-ms-input-placeholder {
    color: #999;
  }
  /deep/ .van-field__control {
    color: #c28831;
  }
}
.van-search__action {
  background-image: radial-gradient(#d8ba79, #c28831);
  padding: 0 32px;
  margin: 0 20px 0 0;
  color: #1b2026;
  border-radius: 20px;
  div {
    font-size: 30px;
  }
}
.search-list {
  padding: 0 40px 40px 40px;
  .User {
    margin-top: 40px;
    border-radius: 16px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('../../../assets/images/user-bg.png');
  }
  .Student {
    margin-top: 40px;
    border-radius: 16px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('../../../assets/images/student-bg.png');
  }
}
.custom-title {
  color: #999999;
}
.name {
  padding: 24px 24px 0 24px;
}
.content {
  color: #999!important;
  margin-top: 16px;
  padding-left: 24px;
  div {
    color: #999!important;
    margin-top: 8px;
  }
}
.state {
  font-weight: bold;
  color: #ff9e19;
}
.bottom {
  font-size: .32rem;
  padding: 24px;
}
.baseinfo {
  margin-top: 24px;
  padding-left: 24px;
  .sex {
    width: 24px;
    height: 24px;
    margin-top: 8px;
    margin-left: 8px;
  }
}
.detailinfo {
  padding-left: 24px;
  padding-top: 8px;
}
.headimg {
  border-radius: 50%;
  height: 120px;
  width: 120px;
}
.font-bigger {
  padding-right: 0px;
}
.font-intro {
  padding-right: 16px;
}
</style>